export default "__VITE_ASSET__DrWCv0l0__"